import { useAtomValue } from "jotai";
import React from "react";

import { DropdownSelectOption } from "@whoosh/design-system/src/components/controls/DropdownSelect";
import { ScrollView } from "@whoosh/design-system/src/components/primitive";

import { primaryChargeSelectionRegistrantListAtom } from "../../../atoms/eventSignUpProcess";
import { RegistrationChargeSelectionRow } from "./RegistrationChargeSelectionRow";

export const PerPersonSelectionList = ({
  eventId,
  fallbackOptions,
}: {
  eventId: string;
  fallbackOptions: DropdownSelectOption<string>[];
}) => {
  const registrations = useAtomValue(primaryChargeSelectionRegistrantListAtom);

  return (
    <ScrollView flex={1}>
      {registrations.map((r) => {
        return (
          <RegistrationChargeSelectionRow
            key={`${r.id}-${r.index}`}
            eventId={eventId}
            registrant={r}
            fallbackOptions={fallbackOptions}
          />
        );
      })}
    </ScrollView>
  );
};
